'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cmsWebContent = exports.cmsLegalContent = exports.cms = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = 'SAGA.API.CMS'; /* eslint-disable import/prefer-default-export */

var SPACES = {
  legal: 'legal',
  webContent: 'consumer_web_content',
  webPage: 'consumer_web'
};

var pathMapping = [{
  path: '/',
  contentfulPath: '/homepage'
}, {
  path: /^(\/invite).*/,
  contentfulPath: '/invite'
}];

var getPathMapping = function getPathMapping(path) {
  var pathMap = pathMapping.find(function (mapping) {
    return mapping.path.test ? mapping.path.test(path) : mapping.path === path;
  });
  return pathMap && pathMap.contentfulPath || path;
};

var cms = exports.cms = (0, _sagaTools.makeEntityScaffold)(NAMESPACE, function (client, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.cms.getContentBySpace(SPACES.webPage, (0, _extends3.default)({
    path: getPathMapping(path)
  }, options)).then(function (_ref) {
    var content = _ref.content;
    return content;
  });
}, { defaultKey: function defaultKey(client, path) {
    return getPathMapping(path);
  } });

var cmsLegalContent = exports.cmsLegalContent = (0, _sagaTools.makeEntityScaffold)(NAMESPACE + '.LEGAL_CONTENT', function (client, path) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { transformToHTML: false };
  return client.cms.getContentBySpace(SPACES.legal, {
    path: path,
    transformToHTML: config.transformToHTML
  }).then(function (_ref2) {
    var content = _ref2.content;
    return content.data;
  });
}, { defaultKey: function defaultKey(client, path) {
    return path;
  } });

var cmsWebContent = exports.cmsWebContent = (0, _sagaTools.makeEntityScaffold)(NAMESPACE + '.WEB_CONTENT', function (client, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.cms.getContentBySpace(SPACES.webContent, (0, _extends3.default)({
    path: path
  }, options)).then(function (_ref3) {
    var content = _ref3.content;
    return content;
  });
}, { defaultKey: function defaultKey(client, path) {
    return path;
  } });